module.exports = __webpack_public_path__ + "img/wa.9cef8c68.png";